import * as React from 'react'
import cn from 'classnames'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons'
import profile1 from './profile-1.png'
import profile2 from './profile-2.png'
import profile3 from './profile-3.png'
import styles from './section-four.module.scss'
import { commonKeyValues } from '../../lib/utils'

const messages = defineMessages({
  heading: {
    defaultMessage:
      '“Vi sparar mängder av tid och huvudvärk i det dagliga arbetet. Jag har dessutom sänkt kostnaderna.”',
    id: 'consultant.section-four.heading',
  },
  quoteOne: {
    defaultMessage:
      '“Vi sparar mängder av tid och huvudvärk i det dagliga arbetet. Jag har dessutom sänkt kostnaderna.”',
    id: 'consultant.section-four.quote-one',
  },
  quoteTwo: {
    defaultMessage: '“Att vi har sänkt våra kostnader för redovisningstjänster med 84% är helt fantastiskt.”',
    id: 'consultant.section-four.quote-two',
  },
  quoteThree: {
    defaultMessage: '“Dooer hjälper oss på ett snabbt, smidigt, proffsigt och nytänkande sätt med bokföringen.”',
    id: 'consultant.section-four.quote-three',
  },
})

const quotes = [
  {
    quote: <FormattedHTMLMessage {...messages.quoteOne} />,
    author: {
      name: 'Jimmy Rosén',
      company: 'Angry Creative',
      image: profile1,
    },
  },
  {
    quote: <FormattedHTMLMessage {...messages.quoteTwo} />,
    author: {
      name: 'Georgios Karpathakis',
      company: 'Underbara ADHD',
      image: profile2,
    },
  },
  {
    quote: <FormattedHTMLMessage {...messages.quoteThree} />,
    author: {
      name: 'Daniel Suontausta',
      company: 'Nordicbox',
      image: profile3,
    },
  },
]

interface IQuotesProps {
  variant?: 'regular' | 'small' | 'extraSmall'
}

export default function Quotes({ variant }: IQuotesProps) {
  const quotesRef = React.createRef<HTMLDivElement>()

  const scroll = (ref: React.RefObject<HTMLDivElement>, dir: 'left' | 'right') => {
    if (ref && ref.current) {
      if (dir === 'left') {
        ref.current.scrollLeft -= ref.current.clientWidth
      } else if (dir === 'right') {
        ref.current.scrollLeft += ref.current.clientWidth
      }
    }
  }

  return (
    <div
      className={cn(
        styles.root,
        variant === 'small' && styles.small,
        variant === 'extraSmall' && [styles.small, styles.extraSmall]
      )}
    >
      {!variant || variant === 'regular' ? (
        <div className={styles.inner}>
          <Arrow dir="left" scroll={() => scroll(quotesRef, 'left')} />

          <div className={styles.quotes} ref={quotesRef}>
            {quotes.map((q) => (
              <div className={styles.quote} key={`${q.author.name} - ${q.author.company}`}>
                <h1>{q.quote}</h1>
                <div className={styles.author}>
                  <img alt="Profile" src={q.author.image} />
                  <div className={styles.text}>
                    <h4>{q.author.name}</h4>
                    <h5>{q.author.company}</h5>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Arrow dir="right" scroll={() => scroll(quotesRef, 'right')} />
        </div>
      ) : (
        <>
          <h3>{quotes[0].quote}</h3>
          <div className={styles.author}>
            <img alt="Profile" src={quotes[0].author.image} />
            <div className={styles.text}>
              <h4>{quotes[0].author.name}</h4>
              <h5>{quotes[0].author.company}</h5>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

const Arrow = ({ scroll, dir }: { scroll: () => void; dir: 'left' | 'right' }) => {
  const icons = { left: faArrowLeft, right: faArrowRight }
  return (
    <i
      onClick={() => scroll()}
      onKeyDown={(e) => e.keyCode === commonKeyValues.enter && scroll()}
      role="button"
      tabIndex={0}
    >
      <FontAwesomeIcon icon={icons[dir]} />
    </i>
  )
}
